export default __webpack_public_path__ + "level-up.png";